import React from "react"
import { Button, Col, Row } from "react-bootstrap"
import withHooks from "../../Common/jsx/WithHooks"

class QuestionFooter extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = {
      isReadyToRender: true,
    }

    this.dMgr.debug("init_state:", this.state)
  }

  componentDidMount() {}

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <Row className="margin-bottom-10 margin-top-30">
        <Col md={12} className="text-center">
          <Button
            variant="secondary"
            onClick={() => {
              this.props.backMenu()
            }}
          >
            {this.props.t("app.backMenu")}
          </Button>

          {!this.props.chosenAnswer && !this.props.answerGiven && (
            <Button
              className="button-color2 margin-left-50"
              onClick={() => {
                this.props.giveAnswer()
              }}
            >
              {this.props.t("app.showAnswer")}
            </Button>
          )}

          {(this.props.chosenAnswer || this.props.answerGiven) && this.props.remainingQuestionsId.length > 0 && (
            <Button
              className="button-color1 margin-left-50"
              onClick={() => {
                this.props.getNextQuestion()
              }}
            >
              {this.props.t("app.nextQuestion")}
            </Button>
          )}
        </Col>
      </Row>
    )

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(QuestionFooter)
